const AlignChildren = ({ children }) => (
	<div className="he-white-b vh-100 d-flex align-items-center justify-content-center">
		{children}
	</div>
);

export default AlignChildren;
